

    //more info: https://tinyurl.com/2p8ttd2b

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Component({ })
    export default class Loader extends Vue {

        @Prop({}) private active !: boolean;
        @Prop({}) private text !: string;

        //To use this as a "waiting" spinner use a setTimeout inside a function, for example:
        //loadData() {
        //    Utils.showLoader();
        //    setTimeout(() => {
        //        const postData = { myData: blah };
        //        const response = await ApiClient.post("/Api/SomeController/SomeMethod", myData);
        //        if (response.isSuccess) {
        //            toastr.success(this.object.email, "Requested");
        //        }
        //        else {
        //            toastr.error(response.message);
        //        }
        //        Utils.hideLoader();
        //    }, 5000);
        //}
        //see EmployeeModal.vue for an example without using setTimeout

    }
